import { render } from "./Carrito.vue?vue&type=template&id=4b0b436d"
import script from "./Carrito.vue?vue&type=script&lang=js"
export * from "./Carrito.vue?vue&type=script&lang=js"

import exportComponent from "M:\\programas-web\\vuejs\\carritoapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__